module.exports = __webpack_public_path__ + "img/cover_photo.292c3eba.jpg";